import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from '../../../../model/State';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import { FormattedMessage } from 'react-intl';
import { messages } from '../cancelSubscription/messages';
import styled from 'styled-components';
import { Dimensions } from '../../../../components/visuals';
import Button from '@atlaskit/button/new';
import TextArea from '@atlaskit/textarea';
import { redirect } from 'redux-first-router';
import * as preselectedLicense from '../../duck/actions/licensesPreselected';

const DomainTextSection = styled.div`
  font-weight: bold;
  text-align: center;
  padding: ${Dimensions.units(2)}px;
`;

const TrialLicenseConfirmationModal = ({ licenseKey, sen }) => {
  const dispatch = useDispatch();
  const callback = useSelector((state: State) => state.location.query?.callback);
  const licenseFieldName = useSelector((state: State) => state.location.query?.licensefieldname);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    if (sen && callback && licenseFieldName && licenseKey) {
      setIsModalOpen(true);
    }
  }, [sen, callback, licenseFieldName, licenseKey]);

  const domain = useMemo(() => {
    try {
      return new URL(callback).hostname;
    } catch {
      return '';
    }
  }, [callback]);

  const closeModal = () => {
    setIsModalOpen(false);
    dispatch(redirect(preselectedLicense.licensePreselectedRoute(sen.toString(), {})));
  };

  const submitForm = () => {
    if (formRef?.current) {
      formRef.current.submit();
    }
  };

  return !isModalOpen ? null : (
    <>
      <ModalTransition>
        <Modal autoFocus={false}>
          <ModalHeader>
            <ModalTitle>
              <FormattedMessage {...messages.trialLicenseConfirmationTitle} />
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <FormattedMessage {...messages.trialLicenseConfirmationBody} />
            <DomainTextSection>{domain}</DomainTextSection>
            <form
              method="POST"
              name="callback-redirect"
              action={callback}
              style={{ display: 'none' }}
              ref={formRef}
            >
              <TextArea name={licenseFieldName} value={licenseKey} />
            </form>
          </ModalBody>
          <ModalFooter>
            <Button appearance="subtle" onClick={closeModal}>
              <FormattedMessage {...messages.trialLicenseConfirmationCancel} />
            </Button>
            <Button appearance="primary" onClick={submitForm}>
              <FormattedMessage {...messages.trialLicenseConfirmationConfirm} />
            </Button>
          </ModalFooter>
        </Modal>
      </ModalTransition>
    </>
  );
};

export default TrialLicenseConfirmationModal;
